import { concat } from '../../helpers/common'

const MODULE_NAME = 'SOCIAL_RETURN_ON_INVESTMENT/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION
export const GET_SROI_REPORTS = concat(MODULE_NAME, 'GET_SROI_REPORTS')
export const GET_SROI_REPORTS_SUCCESS = concat(MODULE_NAME, 'GET_SROI_REPORTS_SUCCESS')
export const GET_SROI_REPORTS_FAILURE = concat(MODULE_NAME, 'GET_SROI_REPORTS_FAILURE')
export const CLEAR_GET_SROI_REPORTS = concat(MODULE_NAME, 'CLEAR_GET_SROI_REPORTS')

export const GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT = concat(MODULE_NAME, 'GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT')
export const GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_SUCCESS = concat(
  MODULE_NAME,
  'GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_SUCCESS'
)
export const GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_FAILURE = concat(
  MODULE_NAME,
  'GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_FAILURE'
)
export const CLEAR_GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT = concat(
  MODULE_NAME,
  'CLEAR_GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT'
)

export const GET_SROI_REPORT_PAYLOAD = concat(MODULE_NAME, 'GET_SROI_REPORT_PAYLOAD')
export const GET_SROI_REPORT_PAYLOAD_SUCCESS = concat(MODULE_NAME, 'GET_SROI_REPORT_PAYLOAD_SUCCESS')
export const GET_SROI_REPORT_PAYLOAD_FAILURE = concat(MODULE_NAME, 'GET_SROI_REPORT_PAYLOAD_FAILURE')
export const CLEAR_GET_SROI_REPORT_PAYLOAD = concat(MODULE_NAME, 'CLEAR_GET_SROI_REPORT_PAYLOAD')

export const CREATE_SROI_REPORT_PAYLOAD = concat(MODULE_NAME, 'CREATE_SROI_REPORT_PAYLOAD')
export const CREATE_SROI_REPORT_PAYLOAD_SUCCESS = concat(MODULE_NAME, 'CREATE_SROI_REPORT_PAYLOAD_SUCCESS')
export const CREATE_SROI_REPORT_PAYLOAD_FAILURE = concat(MODULE_NAME, 'CREATE_SROI_REPORT_PAYLOAD_FAILURE')
export const CLEAR_CREATE_SROI_REPORT_PAYLOAD = concat(MODULE_NAME, 'CLEAR_CREATE_SROI_REPORT_PAYLOAD')

export const UPDATE_SROI_REPORT_PAYLOAD = concat(MODULE_NAME, 'UPDATE_SROI_REPORT_PAYLOAD')
export const UPDATE_SROI_REPORT_PAYLOAD_SUCCESS = concat(MODULE_NAME, 'UPDATE_SROI_REPORT_PAYLOAD_SUCCESS')
export const UPDATE_SROI_REPORT_PAYLOAD_FAILURE = concat(MODULE_NAME, 'UPDATE_SROI_REPORT_PAYLOAD_FAILURE')
export const CLEAR_UPDATE_SROI_REPORT_PAYLOAD = concat(MODULE_NAME, 'CLEAR_UPDATE_SROI_REPORT_PAYLOAD')

export const DELETE_SROI_REPORT_PAYLOAD = concat(MODULE_NAME, 'DELETE_SROI_REPORT_PAYLOAD')
export const DELETE_SROI_REPORT_PAYLOAD_SUCCESS = concat(MODULE_NAME, 'DELETE_SROI_REPORT_PAYLOAD_SUCCESS')
export const DELETE_SROI_REPORT_PAYLOAD_FAILURE = concat(MODULE_NAME, 'DELETE_SROI_REPORT_PAYLOAD_FAILURE')
export const CLEAR_DELETE_SROI_REPORT_PAYLOAD = concat(MODULE_NAME, 'CLEAR_DELETE_SROI_REPORT_PAYLOAD')

export const GET_SROI_INPUTS_PRESET = concat(MODULE_NAME, 'GET_SROI_INPUTS_PRESET')
export const GET_SROI_INPUTS_PRESET_SUCCESS = concat(MODULE_NAME, 'GET_SROI_INPUTS_PRESET_SUCCESS')
export const GET_SROI_INPUTS_PRESET_FAILURE = concat(MODULE_NAME, 'GET_SROI_INPUTS_PRESET_FAILURE')
export const CLEAR_GET_SROI_INPUTS_PRESET = concat(MODULE_NAME, 'CLEAR_GET_SROI_INPUTS_PRESET')

export const UPDATE_SROI_INPUTS_PRESET = concat(MODULE_NAME, 'UPDATE_SROI_INPUTS_PRESET')
export const UPDATE_SROI_INPUTS_PRESET_SUCCESS = concat(MODULE_NAME, 'UPDATE_SROI_INPUTS_PRESET_SUCCESS')
export const UPDATE_SROI_INPUTS_PRESET_FAILURE = concat(MODULE_NAME, 'UPDATE_SROI_INPUTS_PRESET_FAILURE')
export const CLEAR_UPDATE_SROI_INPUTS_PRESET = concat(MODULE_NAME, 'CLEAR_UPDATE_SROI_INPUTS_PRESET')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

// Get sroi reports
export function getSroiReports(params) {
  return { type: GET_SROI_REPORTS, params }
}

export function getSroiReportsSuccess(data) {
  return { type: GET_SROI_REPORTS_SUCCESS, data }
}

export function getSroiReportsFailure(error) {
  return { type: GET_SROI_REPORTS_FAILURE, error }
}

export function clearGetSroiReports() {
  return { type: CLEAR_GET_SROI_REPORTS }
}

export function getSocialReturnOnInvestmentReport(params) {
  return { type: GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT, params }
}

export function getSocialReturnOnInvestmentReportSuccess(data) {
  return { type: GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_SUCCESS, data }
}

export function getSocialReturnOnInvestmentReportFailure(error) {
  return { type: GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT_FAILURE, error }
}

export function clearGetSocialReturnOnInvestmentReport() {
  return { type: CLEAR_GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT }
}

// Get sroi report
export function getSroiReportPayload(params) {
  return { type: GET_SROI_REPORT_PAYLOAD, params }
}

export function getSroiReportPayloadSuccess(data) {
  return { type: GET_SROI_REPORT_PAYLOAD_SUCCESS, data }
}

export function getSroiReportPayloadFailure(error) {
  return { type: GET_SROI_REPORT_PAYLOAD_FAILURE, error }
}

export function clearGetSroiReportPayload() {
  return { type: CLEAR_GET_SROI_REPORT_PAYLOAD }
}

// Create sroi report payload
export function createSroiReportPayload(data) {
  return { type: CREATE_SROI_REPORT_PAYLOAD, data }
}

export function createSroiReportPayloadSuccess(data) {
  return { type: CREATE_SROI_REPORT_PAYLOAD_SUCCESS, data }
}

export function createSroiReportPayloadFailure(error) {
  return { type: CREATE_SROI_REPORT_PAYLOAD_FAILURE, error }
}

export function clearCreateSroiReportPayload() {
  return { type: CLEAR_CREATE_SROI_REPORT_PAYLOAD }
}

// Update sroi report
export function updateSroiReportPayload(id, data) {
  return { type: UPDATE_SROI_REPORT_PAYLOAD, id, data }
}

export function updateSroiReportPayloadSuccess(data) {
  return { type: UPDATE_SROI_REPORT_PAYLOAD_SUCCESS, data }
}

export function updateSroiReportPayloadFailure(error) {
  return { type: UPDATE_SROI_REPORT_PAYLOAD_FAILURE, error }
}

export function clearUpdateSroiReportPayload() {
  return { type: CLEAR_UPDATE_SROI_REPORT_PAYLOAD }
}

// Delete sroi report payload
export function deleteSroiReportPayload(params) {
  return { type: DELETE_SROI_REPORT_PAYLOAD, params }
}

export function deleteSroiReportPayloadSuccess(data) {
  return { type: DELETE_SROI_REPORT_PAYLOAD_SUCCESS, data }
}

export function deleteSroiReportPayloadFailure(error) {
  return { type: DELETE_SROI_REPORT_PAYLOAD_FAILURE, error }
}

export function clearDeleteSroiReportPayload() {
  return { type: CLEAR_DELETE_SROI_REPORT_PAYLOAD }
}

// Get sroi inputs preset
export function getSroiInputsPreset(params) {
  return { type: GET_SROI_INPUTS_PRESET, params }
}

export function getSroiInputsPresetSuccess(data) {
  return { type: GET_SROI_INPUTS_PRESET_SUCCESS, data }
}

export function getSroiInputsPresetFailure(error) {
  return { type: GET_SROI_INPUTS_PRESET_FAILURE, error }
}

export function clearGetSroiInputsPreset() {
  return { type: CLEAR_GET_SROI_INPUTS_PRESET }
}

// Update sroi inputs preset
export function updateSroiInputsPreset(params, data) {
  return { type: UPDATE_SROI_INPUTS_PRESET, params, data }
}

export function updateSroiInputsPresetSuccess(data) {
  return { type: UPDATE_SROI_INPUTS_PRESET_SUCCESS, data }
}

export function updateSroiInputsPresetFailure(error) {
  return { type: UPDATE_SROI_INPUTS_PRESET_FAILURE, error }
}

export function clearUpdateSroiInputsPreset() {
  return { type: CLEAR_UPDATE_SROI_INPUTS_PRESET }
}
